export enum WorkbenchEvents {
  DocumentationOpened = 'workbench.help.DocumentationOpened',
  KeyboardShortcutsOpened = 'workbench.help.KeyboardShortcutsOpened',
  ContactSupport = 'workbench.help.ContactSupport',
  SidebarCloseWidget = 'workbench.sidebar.CloseWidget',
  SidebarOpenWidget = 'workbench.sidebar.OpenWidget',
  Connect = 'workbench.Connect'
}
